import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { ReactComponent as Close } from '../../assets/img/close.svg';
import './EventPopup.scss';
import moment from "moment";

const EventPopup = ({ event, onClose }) => {
  const { start, end, title, description, image } = event;

  const startTime = moment(start).format('dddd, D MMMM, H:mm')
  const endTime = end ? moment(end).format('H:mm') : '';

  const text = description ? description.split('\n').map((item, i) => <p key={i}>{item ? item : <>&nbsp;</>}</p>) : null;

  return (
    <div className="xti-event-popup">
      <div className="xti-event-popup__overlay" onClick={onClose} />
      <div className="xti-event-popup__container">
        <button className="xti-event-popup__close-btn" type="button" onClick={onClose}><Close /></button>
        <Scrollbars>
          <div className="xti-event-popup__content">
            {image && <img className="xti-event-popup__image" src={image} alt={title}/>}
            {startTime && <div className="xti-event-popup__date">{startTime} {endTime && `- ${endTime}`}</div>}
            {title && <div className="xti-event-popup__title">{title}</div>}
            {text && <div className="xti-event-popup__description">{text}</div>}
          </div>
        </Scrollbars>
      </div>
    </div>
  );
};

EventPopup.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EventPopup;
